import React from "react";
import { useTranslation } from "react-i18next";
import NoRecordFound from "../Common/NoRecordFound";
import { useSelector } from "react-redux";

const StoreStatus = () => {
  const { t } = useTranslation();
  const data = useSelector((state) => state.Dashboard?.data) || [];

  const branches = data?.storeStatus?.branches || [];
  // return;
  const STORE_STATUS = branches.map((branch) => ({
    id: branch.branchId,
    name: branch.name,
    washes: branch.totalWashes,
    status: branch.storeStatus === "Open" ? "online" : "down",
    progress:
      branch.trafficStatus === "Low"
        ? 30
        : branch.trafficStatus === "Medium"
          ? 60
          : 90,
  }));

  return (
    <div className="store_status">
      <h3 className="fs_20 store_status__title">{t("Store Status")}</h3>

      <div className="store_inner common_scrollbar">
        {STORE_STATUS.length === 0 ? (
          <NoRecordFound title={t("No store status found")} />
        ) : (
          STORE_STATUS.map((store) => (
            <div key={store.id} className="store_card">
              <div className="store_card__top">
                <div>
                  <h4>{store.name}</h4>
                  <p>
                    {store.washes} {t("Washes")}
                  </p>
                </div>

                <span
                  className={`store_badge ${
                    store.status === "online"
                      ? "store_badge--online"
                      : "store_badge--down"
                  }`}
                >
                  {store.status === "online" ? t("Open") : t("Closed")}
                </span>
              </div>

              <div className="store_progress">
                <span
                  className={`store_progress__bar ${
                    store.status === "online"
                      ? "progress--online"
                      : "progress--down"
                  }`}
                  style={{ "--target-width": `${store.progress}%` }}
                />
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default StoreStatus;
